<template>
  <div class="record">
      <div class="recordContainer">
        <div class="date">
           <div class="year">
              {{yearN}}年
              <span class="toTop" v-show="isYear=='2'"   @click="showYear()"></span>
              <span class="toTop toTop1" v-show="isYear=='1'"   @click="hideYear()"></span>
              <!-- <img src="../../assets/img/down.png" alt=""  > 
              <img src="../../assets/img/top.png" alt=""  v-show="isYear=='1'"   @click="hideYear()">  -->
           </div>
           <div style="color:rgba(0,0,0,.1)">|</div>
           <div class="month">
              {{monthN}} <span v-if="monthN!='全部'">月</span>
              <span class="toTop toTop2" v-show="isMonth=='2'"    @click="showMonth()"></span>
              <span class="toTop toTop2 toTop1 " v-show="isMonth=='1'"   @click="hideMonth()"></span>
              <!-- <img src="../../assets/img/down.png" alt=""  > 
              <img src="../../assets/img/top.png" alt=""   >  -->
           </div>
        </div>
        <div class="timeContainer">
          <div class="noScroll">
           <div class="yearCon"  v-if="isYear=='1'" >
             <div class="dan" v-for="(item,index) in years" :key="index" :class="{active:itemY==item}" @click="itemY=item,changeYear(item)">
               {{item}}年
             </div>
           </div>
            <div class="yearCon monthCon"   v-if="isMonth=='1'" >
             <div class="dan" v-for="(item, index) in months" :key="index" :class="{active:itemM==item}"  @click="itemM=item,changeMonth(item, index)" >
               {{item}} <span v-if="item!='全部'">月</span>
             </div>

            </div>
           </div>
        </div>
          <div class="records"  ref="wrapper" :style="{ height: (wrapperHeight-10) + 'px' }" style="overflow-y:scroll;" >
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" bottomDropText="正在加载" bottomPullText="上拉加载更多" ref="loadmore" :auto-fill="false"   @top-status-change="handleTopChange"  @bottom-status-change="handleBottomChange">
              <div  class="zhanwei"  :style="{ height: (wrapperHeight) + 'px' }"  v-show="chargeRecords.length =='0'">
                <div>     
                  <p>
                    <img src="../../assets/img/noRecord.png" alt="">
                  </p>
                  <p style="margin-top:0.4rem;font-weight:400;font-size: 0.28rem;color:rgba(153,153,153,1);">暂未找到任何记录</p>
                </div>
              </div>
              
              <div class="chargeRecord"  v-show="chargeRecords.length !='0'"  style="overflow-y:scroll;"  :style='{"min-height":(wrapperHeight-50) + "px"}'>
                <div class="dan" v-for="(item,index) in chargeRecords" :key="index"  style="position:relative;">
                    <div class="left" >
                      <p class="bean" v-if="whatRecord=='1' && item.type!= '17'" >
                         
                          购买播豆
                          <img src="../../assets/img/balancePay.png" alt="" style="width:1.08rem;position:absolute;top:0.03rem;" v-if="item.type=='12'">
                      </p>
                      <p class="bean" v-if="whatRecord=='1' && item.type == '17'" >
                         
                          运营活动奖励
                          <img src="../../assets/img/balancePay.png" alt="" style="width:1.08rem;position:absolute;top:0.03rem;" v-if="item.type=='12'">
                      </p>
                      <p class="bean" v-if="whatRecord=='2'&& item.type != '-17'">购买了{{item.num}}个{{item.gift_name}}</p>
                      <p class="bean" v-if="whatRecord=='2'&& item.type == '-17'">运营活动消耗</p>
                      <p class="bean" v-if="whatRecord=='6'"> {{item.type | isType}} 
                        <img src="../../assets/img/goldImg.png" alt="" style="width:0.36rem;vertical-align: bottom;"  v-if="item.type=='16'">
                      </p>
                      <!-- <p class="bean" v-if="whatRecord=='3'">兑换{{item.amount}}播豆</p>
                      <p class="bean" v-if="whatRecord=='4'">提现{{Number(item.amount)/100}}元</p> -->
                      <p class="dates" >{{item.created | formatDate}}</p>
                    </div>
                    <div class="right">
                      <!-- <p v-if="whatRecord=='1' || whatRecord=='2'"  class="status">{{item.status | isStatus}}</p> -->
                      <p v-if="whatRecord=='1'"  class="status" >
                        <span v-if="item.type!='-8'" style="color:rgba(255,181,22,1);">+</span> 
                        <span v-if="item.type!='-8'" style="color:rgba(255,181,22,1);">{{Number(item.amount)/10}} </span>
                        <span v-if="item.type=='-8'">{{Number(item.amount)/10}} </span>
                        <img src="../../assets/img/bean.png" alt="" style="width:0.4rem;vertical-align: sub;">
                      </p>
                      <p v-if="whatRecord=='2'"  class="status" style="color:rgba(51,51,51,1);">
                          <span>-</span>
                          {{Number(item.amount)/10}} 
                        <img src="../../assets/img/bean.png" alt="" style="width:0.4rem;vertical-align: sub;">
                      </p>
                      <div v-if="whatRecord=='7'"   class="isRight">
                        <p class="bean" v-if="whatRecord=='7'&& item.type != '-17'">{{item.msg}}</p>
                        <p class="isAmount">
                         <span v-if="Number(item.amount)/100 >0"  style="color:rgba(255,0,0,1);">+</span>
                         <span  class="isSpan" style="color:rgba(255,0,0,1);;font-size:0.28rem;margin-right:0.28rem;"> {{item.amount}} </span>
                        </p>
                      </div>  
                      <div v-if="whatRecord=='8'"  class="isRight">
                         <p class="bean" v-if="whatRecord=='8'&& item.type != '-17'">{{item.msg}}</p>
                         <p class="isAmount">
                            <span v-if="Number(item.amount)/100 >0"  style="color:rgba(255,0,0,1);">+</span>
                            <span  class="isSpan" style="color:rgba(255,0,0,1);;font-size:0.28rem;margin-right:0.28rem;"> {{item.amount}} </span>
                        </p>
                      </div>
                      <p  v-if="whatRecord=='6'" >
                        <span v-if="Number(item.amount)/100 >0"  style="color:rgba(255,181,22,1);">+</span>
                        <span v-if="Number(item.amount)/100 >0"  style="color:rgba(255,181,22,1);">{{Number(item.amount)/100 }} 元</span> 
                        <span  v-if="Number(item.amount)/100 <0">{{Number(item.amount)/100 }} 元</span> 
                      </p>
                      <!-- <p v-if="whatRecord=='4'" class="status">{{item.status | isStatus1}}</p>
                      <p  v-if="whatRecord=='3'">{{Number(item.money)/100}}元</p>
                      <p style="height:0.6rem;line-height:0.6rem;"  v-if="whatRecord=='5'">+{{Number(item.amount)/100}}元</p> -->
                      
                    </div>
                </div>
              </div>
             <div v-if="allLoaded" style="text-align:center;" class="data-none">我们是有底线的</div>
            </mt-loadmore>

          </div>
      </div>

    
  </div>                                                                                                                                                          

  
</template>

<script>

import cbct from '../../assets/js/common/base.js';
import { Toast } from 'mint-ui';
import { Loadmore } from 'mint-ui';
export default {
  name: 'record',
  data:function(){
    return{
      yearN:'',
      monthN:'',
      years:[],
      months:[],
      isYear:'2',
      isMonth:'2',
      whatRecord:'',
      chargeRecords:[],
      itemY:'',
      itemM:'',
      page:1,
      pageSize:10,
      allLoaded:false,//是否加载完毕
      haveMore:true,//是否有更多数据
      scrollMode:'auto',
      topStatus: '',//顶部下拉加载状态
      bottomStatus: '',//底部上拉加载状态
      wrapperHeight:0,
      isImg:'1',
      zheng:false,
    }
  },

  methods:{

    getTimeN:function(){
      var myDate=new Date();
      this.yearN=myDate.getFullYear();
      this.itemY=myDate.getFullYear();
      this.monthN=myDate.getMonth()+1;
      this.itemM=myDate.getMonth()+1;
    },
    getYears:function(){
      var date=new Date();
      var yearN=date.getFullYear();
      var section=yearN - 2017;
      for(var i = 0;i<=section;i++){
       this.years.push(yearN--)
      }
    },
    getMonths:function(){
      var date=new Date();
      var yearN=date.getFullYear();
      // console.log('yearN',yearN);
      if (this.yearN==yearN) {
            var date1=new Date();
            var monthN=date1.getMonth()+1;
            // var section1=monthN - 1;
            for(let i = 1;i<=monthN;i++){
              this.months.unshift(i);
            }
            // console.log('获取月份下的this.months',this.months);
      }else{
          for(let i = 0;i<=12;i++){
            this.months.unshift(i)
          }
      }
    },
    changeYear:function(year){
        this.yearN=year; 
        this.isYear='2';
        let self=this;
        if (self.whatRecord=='1') {
          self.chargeRecord();
        }else if(self.whatRecord=='2'){
          self.consumeRecorded(); 
        }
        // else if(self.whatRecord=='3'){
        //   self.exchangeRecorded();
        // }else if(self.whatRecord=='4'){
        //   self.extractRecorded();
        // }else if(self.whatRecord=='5'){
        //   self.earningsRecorded();
        // }
        else if(self.whatRecord=='6'){
         self.walletRecorded();
       }else if(self.whatRecord=='7'){
         self.tradeRecorded();
        //  console.log('444');
       }else if(self.whatRecord=='8'){
         self.balanceRecorded();
       }
        //  this.isPosition();

    },
    changeMonth:function(month, index){
        this.monthN=month;
        this.isMonth='2';
        // let self=this;
      //   if (self.whatRecord=='1') {
      //     self.chargeRecord();
      //   }else if(self.whatRecord=='2'){
      //     self.consumeRecorded(); 
      //   }
      //   // else if(self.whatRecord=='3'){
      //   //   self.exchangeRecorded();
      //   // }else if(self.whatRecord=='4'){
      //   //   self.extractRecorded();
      //   // }else if(self.whatRecord=='5'){
      //   //   self.earningsRecorded();
      //   // }
      //   else if(self.whatRecord=='6'){
      //    self.walletRecorded();
      //  }else if(self.whatRecord=='7'){
      //    self.tradeRecorded();
      //    console.log('333');
      //  }else if(self.whatRecord=='8'){
      //    self.balanceRecorded();
      //  }
        //  this.isPosition();
    },
  
    showYear:function(){
      this.isYear='1';
      this.isMonth='2';
      
    },
    hideYear:function(){
      this.isYear='2';
    },
    showMonth:function(){
      this.isMonth='1';
      this.isYear='2';

    },
    hideMonth:function(){
      this.isMonth='2';
    },
    handleTopChange(status) {
        this.topStatus = status;
    },
    handleBottomChange(status) {
        this.bottomStatus = status;
    },
    loadBottom:function(){//上拉加载
       if (!this.allLoaded) {
      
        this.handleBottomChange("loading");//上拉时 改变状态码
        this.page+=1;
      
        let self =this;
        if (self.whatRecord=='1') {
          self.chargeRecord();
         
        }else if(self.whatRecord=='2'){
          self.consumeRecorded(); 
        }
        // else if(self.whatRecord=='3'){
        //   self.exchangeRecorded();
        // }else if(self.whatRecord=='4'){
        //   self.extractRecorded();
        // }else if(self.whatRecord=='5'){
        //   self.earningsRecorded();
        // }
        else if(self.whatRecord=='6'){
         self.walletRecorded();
        }else if(self.whatRecord=='7'){
         self.tradeRecorded();
        //  console.log('555');
       }else if(self.whatRecord=='8'){
         self.balanceRecorded();
       }
        this.handleBottomChange("loadingEnd");//数据加载完毕 修改状态码
        this.$refs.loadmore.onBottomLoaded();

         
       }else{
         this.allLoaded=true;
      
       }
      
     
    },
    loadTop:function(){
        this.handleTopChange("loading");//下拉时 改变状态码
        this.page=1;
        let self=this;
        this.allLoaded=false;
        if (self.whatRecord=='1') {
          self.chargeRecord();
        }else if(self.whatRecord=='2'){
          self.consumeRecorded(); 
        }
        // else if(self.whatRecord=='3'){
        //   self.exchangeRecorded();
        // }else if(self.whatRecord=='4'){
        //   self.extractRecorded();
        // }else if(self.whatRecord=='5'){
        //   self.earningsRecorded();
        // }
        else if(self.whatRecord=='6'){
         self.walletRecorded();
        }else if(self.whatRecord=='7'){
         self.tradeRecorded();
        //  console.log('222');
       }else if(self.whatRecord=='8'){
         self.balanceRecorded();
       }
         this.handleTopChange("loadingEnd")//数据加载完毕 修改状态码
         this.$refs.loadmore.onTopLoaded();//固定方法 查询完调用用于重新定位  
       

    },
    more(){
      this.page=parseInt(this.page)+1;
      let self=this;
      if (self.whatRecord=='1') {
        self.chargeRecord();
      }else if(self.whatRecord=='2'){
        self.consumeRecorded(); 
      }
      // else if(self.whatRecord=='3'){
      //   self.exchangeRecorded();
      // }else if(self.whatRecord=='4'){
      //   self.extractRecorded();
      // }else if(self.whatRecord=='5'){
      //   self.earningsRecorded();
      // }
      else if(self.whatRecord=='6'){
         self.walletRecorded();
       }else if(self.whatRecord=='7'){
         self.tradeRecorded();
        //  console.log('666');
       }else if(self.whatRecord=='8'){
         self.balanceRecorded();
       }
      
    },
    ishaveMore:function(){
      this.allLoaded=true;
      if (this.haveMore) {
        this.allLoaded=false;
      }
  
    },

    // 充值记录
    chargeRecord:function(){
        this.allLoaded=false;
        var self = this;
        var obj={
          year:this.yearN,
          month:this.monthN,
          pageSize:'12',
          page:this.page,
        }
       
        if (this.monthN=='全部') {
          this.$set(obj,'rt','1');
          delete obj.month;
        }
        self.http.post(this.cbct.https()+'/h5/channel/account/beans-charge-record', this.qs.stringify(
          obj
        )).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d.item;
                 }else {
                   let chargeRecords1=response.d.item;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();

                 }
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
           
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
                 this.$refs.Loadmore.onTopLoaded();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                // Toast({
                //     message: '服务器开小差，请稍后重试',
                //     position: 'center',
                //     duration: 5000
                // });
                this.$refs.Loadmore.onTopLoaded();
                setTimeout(function(){
                    self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
                },1000)   
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                this.$refs.Loadmore.onTopLoaded();
            }
           
        }
        ).catch((error)=>{console.log(error);})
    },
      // 消费记录
      consumeRecorded:function(){
         this.allLoaded=false;
          var self = this;
          var obj={
            year:this.yearN,
            month:this.monthN,
            pageSize:'12',
            page:this.page,
          }
          
          if (this.monthN=='全部') {
            this.$set(obj,'rt','1');
            delete obj.month;
          }
        self.http.post(this.cbct.https()+'/h5/channel/account/beans-consume-record', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                    let d=response.d;
                      var length=0;
                      if (d.length==length) {
                        this.haveMore=false;
                        this.ishaveMore();
                        this.page=1;
                      }
                    else if(this.page==1){
                        this.chargeRecords=response.d.item;
                      }else {
                        let chargeRecords1=response.d.item;
                        this.haveMore=true;
                        this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                        this.ishaveMore();
                      }
                      this.$nextTick(function(){
                        this.scrollMode="touch";
                      })
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 5000
                    });
                    timing.time();
                }else if(response.c ==this.cbct.code.raleNoLogin){
                    self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 5000
                    });
                }
            }
        ).catch((error)=>{console.log(error);})

      },
      // 兑换记录
      exchangeRecorded:function(){
            this.allLoaded=false;
            var self = this;
            var obj={
              year:this.yearN,
              month:this.monthN,
              pageSize:'12',
              page:this.page,
            }
            if (this.monthN=='全部') {
              this.$set(obj,'rt','1');
              delete obj.month;
            }
          self.http.post(this.cbct.https()+'/h5/channel/account/transfer-log', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                   
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d.item;
                 }else {
                   let chargeRecords1=response.d.item;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();

                 }
                 
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                  self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})
      },
      // 提取记录
      extractRecorded:function(){
          var self = this;
          this.allLoaded=false;
          var self = this;
          var obj={
            year:this.yearN,
            month:this.monthN,
            pageSize:'12',
            page:this.page,
            type:'withdraw',
          }
          if (this.monthN=='全部') {
            this.$set(obj,'rt','1');
            delete obj.month;
          }
          self.http.post(this.cbct.https()+'/h5/channel/account/withdraw-log', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d.item;
                 }else {
                   let chargeRecords1=response.d.item;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();

                 }
                 
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})

      },
      // 收益记录
      earningsRecorded:function(){
           this.allLoaded=false;
            var self = this;
            var obj={
              year:this.yearN,
              month:this.monthN,
              pageSize:'12',
              page:this.page,
            }
            if (this.monthN=='全部') {
              this.$set(obj,'rt','1');
              delete obj.month;
            }
          self.http.post(this.cbct.https()+'/h5/channel/account/bonus-income-record', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d.item;
                 }else {
                   let chargeRecords1=response.d.item;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();
                 }
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})



      },
       // 钱袋记录
      walletRecorded:function(){
           this.allLoaded=false;
            var self = this;
            var obj={
              year:this.yearN,
              month:this.monthN,
              pageSize:'12',
              page:this.page,
            }
            if (this.monthN=='全部') {
              this.$set(obj,'rt','1');
              delete obj.month;
            }
          self.http.post(this.cbct.https()+'/h5/channel/account/bonus-record', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d.item;
                 }else {
                   let chargeRecords1=response.d.item;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();
                 }
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})



      },
        // 交易记录
      tradeRecorded:function(){
           this.allLoaded=false;
            var self = this;
            var obj={
              year:this.yearN,
              month:this.monthN,
              pageSize:'12',
              page:this.page,
            }
            if (this.monthN=='全部') {
              this.$set(obj,'rt','1');
              delete obj.month;
            }
          self.http.post(this.cbct.https()+'/channel/my/trading-list', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d;
                 }else {
                   let chargeRecords1=response.d;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                  //  console.log('this.chargeRecords',this.chargeRecords)
                   this.ishaveMore();
                 }
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})



      },
       // 收支明细
      balanceRecorded:function(){
           this.allLoaded=false;
            var self = this;
            var obj={
              year:this.yearN,
              month:this.monthN,
              pageSize:'12',
              page:this.page,
            }
            if (this.monthN=='全部') {
              this.$set(obj,'rt','1');
              delete obj.month;
            }
          self.http.post(this.cbct.https()+'/channel/my/balance-list', this.qs.stringify(obj)).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                 let d=response.d;
                 var length=0;
                 if (d.length==length) {
                    this.haveMore=false;
                    this.ishaveMore();
                    this.page=1;
                 }
                else if(this.page==1){
                   this.chargeRecords=response.d;
                 }else {
                   let chargeRecords1=response.d;
                   this.haveMore=true;
                   this.chargeRecords=this.chargeRecords.concat(chargeRecords1);
                   this.ishaveMore();
                 }
                 this.$nextTick(function(){
                   this.scrollMode="touch";
                 })
            
            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=record?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
        }
        ).catch((error)=>{console.log(error);})
      },
  },
  filters:{
    isZheng(zheng){
      var self=this;
      if (Number(zheng)>0) {
        return Number(zheng)
      }else if(Number(zheng)<0){
       return Number(zheng)
      }

    },
    formatDate(time) {
      var date = new Date(time*1000);
      return cbct.formatDate(date, 'MM月dd日');
    },
    isStatus(status){
      if (status=='1') {
        return "成功"
      }else if(status=='0'){
        return "失败"
      }

    },
    isStatus1(status){
      if (status=='0') {
        return "申请中"
      }else if(status=='1'){
        return "完成"
      }else if(status=='2'){
        return "失败"
      }
    },
    isType(type){
    
      if (type=='14') {
        return "余额充值"
      }else if(type=='16'){
        return "余额充值"
      }else if(type=='13'){
        return "领取福袋"
      }else if(type=='-12'){
         return "兑换播豆"
      }else if(type=='15'){
        return "退还福袋"
      }else if(type=='-15'){
        return "发放福袋"
      }else if(type=='-4'){
        return "余额提现"
      }else if(type =='4'){
        return "自动返还（提现失败）"
      }else if(type == '7'){
        return "听见广播赠送"
      }else if(type=='-9'){
        return "发放粉丝专享福袋"
      }else if(type=='9'){
        return "退还福袋（粉丝专享福袋）"
      }

    }
  },
  created(){
      //判断是否授权
      if(this.cbct.getCookie('openId') == undefined ||this.cbct.getCookie('openId') == ''){
          this.$router.push({path:'./change?channel_id='+this.$route.query.Truechnnel_id});
      }


       this.getYears();
       this.getTimeN();
       this.getMonths();
        $('title').html(decodeURIComponent(this.cbct.getCookie('channel_name')));
       let self=this;
       self.whatRecord=self.$route.query.whatRecord;
      //  if (self.whatRecord=='1') {
      //    self.chargeRecord();
      //  }else if(self.whatRecord=='2'){
      //    self.consumeRecorded(); 
      //  }
      //  else if(self.whatRecord=='3'){
      //    self.exchangeRecorded();
      //  }else if(self.whatRecord=='4'){
      //     self.extractRecorded();
      //  }else if(self.whatRecord=='5'){
      //     self.earningsRecorded();
      //  }
      //  else if(self.whatRecord=='6'){
      //    self.walletRecorded();
      //  }else if(self.whatRecord=='7'){
      //    self.tradeRecorded();
      //    console.log('111');
      //  }else if(self.whatRecord=='8'){
      //    self.balanceRecorded();
      //  }
  },
  mounted(){
      this.wrapperHeight =
      document.documentElement.clientHeight -
      this.$refs.wrapper.getBoundingClientRect().top;
      document.body.style.background="rgba(249,249,249,1)";
  },
  components: {
  },
  watch:{
    yearN:function(n,o){
        let self=this;
        self.chargeRecords=[];
        this.months=[];
        var date=new Date();
        var yearN1=date.getFullYear();
        console.log('yearN1',yearN1);
       if (n==yearN1) {

            var date1=new Date();
            var monthN=date1.getMonth()+1;
            var section1=monthN - 1;
            for(let i = 0;i<=section1;i++){
              this.months.unshift(monthN--)
            }
            var all='全部';
            this.months.unshift(all);
            console.log('监听下的month',this.months);
            // this.isPosition();

      }else{
          for(let i = 0;i<12;i++){
            this.months.push(i+1)
          }
          var all='全部';
          this.months.unshift(all);
        
      }

    },
    monthN:function(n,o){
        let self=this;
        self.chargeRecords=[];
      
        if (self.whatRecord=='1') {
          self.chargeRecord();
        }else if(self.whatRecord=='2'){
          self.consumeRecorded(); 
        }
        // else if(self.whatRecord=='3'){
        //   self.exchangeRecorded();
        // }else if(self.whatRecord=='4'){
        //   self.extractRecorded();
        // }else if(self.whatRecord=='5'){
        //   self.earningsRecorded();
        // }
        else if(self.whatRecord=='6'){
         self.walletRecorded();
       }else if(self.whatRecord=='7'){
         self.tradeRecorded();
        //  console.log('777');
       }else if(self.whatRecord=='8'){
         self.balanceRecorded();
       }

    }



  },
 
}


</script>
<style scoped lang="scss">
   .record{
      width: 100%;
      box-sizing: border-box;
      height: auto;
      overflow-y: hidden;

      .recordContainer{
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        // height: 100%;
        .date{
          width: 100%;
          display: flex;
          align-items: center;
          font-size:0.28rem;
          height: 1rem;
          line-height: 1rem;
          // padding: 0.23rem 0;
          font-weight:400;
          color:rgba(0,0,0,0.8);
          background:rgba(249,249,249,1) !important;
          border-bottom:solid 1px rgba(0,0,0,.1); 
          position: fixed;
          z-index: 3;
          top: 0;
          left: 0;
          .toTop{
            position: absolute;
            top: 0.42rem;
            left: 2.4rem;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid rgba(0,0,0,.1);
          }
          .toTop2{
            left: 6rem;
          }
          .toTop1{
            border-top: none;
            border-bottom: 5px solid rgba(0,0,0,.1); 
          }
          img{
            width: 0.3rem;
            margin-left: 0.3rem;
          }
          .year{
            width: 49.8%;
            text-align: center;
            position: relative;
          }
          .month{
            width: 49.8%;
            text-align: center;
          }
        }
        .timeContainer{
          width: 100%;
          box-sizing: border-box;
          // border: solid 1px;
          font-size: 0.3rem;
          text-align: left;
          box-sizing: border-box;
          z-index: 100;
          position: absolute;
          top: 0.88rem;
          background:rgba(248,248,248,1);
          .active{
            color: rgba(252,204,100,1)
          }
          .noScroll{
            width: 100%;
            overflow: hidden;
            .yearCon{
            width: 102%;
            height: 2.73rem;
            overflow-x: hidden;
            border-bottom: solid 1px rgba(0,0,0,.1);
            // overflow-y: scroll;
            .dan{
              width: 100%;
              height: 0.89rem;
              line-height: 0.88rem;
              border-bottom: solid 1px rgba(0,0,0,.1);
              padding-left: 1.1rem; 
            }
            .dan:last-of-type{
                border: none;
             }

           
           }
           .yearCon:first-of-type{
               border-top: solid 1px rgba(0,0,0,.1);
           }
           
           .monthCon{
             height: 3.52rem;
            .dan:last-of-type{
                border: none;
             }

           }
          }
          
         
        }
        .records{
          width: 100%;
          box-sizing: border-box;
          font-size: 0.24rem;
          font-weight: 500;
          // height: 100%;
          padding-top: 1rem;
          overflow-x: hidden;
          overflow-y: scroll;   
          -webkit-overflow-scrolling: touch;
          .zhanwei{
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 3rem;

            }
          }
          .chargeRecord{
            width: 100%;
            box-sizing: border-box;
            .dan{
              box-sizing: border-box;
              height: 1.6rem;
              padding: 0.32rem 0rem 0.22rem 0.3rem;
              border-top: solid 1px rgba(0,0,0,.1);
              .left{
                text-align: left;
                .bean{
                  font-size: 0.32rem;
                  font-weight: 500;
                  margin-bottom: 0.1rem;
                  color:rgba(51,51,51,1);
                }
                .dates{
                  font-size: 0.24rem;
                  color:rgba(0,0,0,0.5);
                  margin-bottom: 0.3rem;
                  line-height: 1;
                  font-weight:500;
                }
              
               
              }
              .right{
                box-sizing: border-box;
                .isRight{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .bean{
                      font-weight:500;
                      color:rgba(0,0,0,0.7);
                      font-size:0.3rem;
                    }
                    .isAmount{
                     
                      .isSpan{
                      }
                    }
                }
                .status{
                  font-size: 0.3rem;
                  font-weight:400;
                }
              }
              
            }
            .dan:first-of-type{
              border-top: none;
            }
            .dan:last-of-type{
              border-bottom:solid 1px rgba(0,0,0,.1); 
            }


          }

        }
        .records::-webkit-scrollbar {
          display: none;
        }    
      }
      .data-none{
        font-size: 0.24rem;
        display: flex;
        align-items: center;
        height: 1rem;
        justify-content: center;
        // margin-top: 1rem;
      }
    
     
   }
  div::-webkit-scrollbar {
    display: none;
  }  
 
</style>

